
import { Condition } from "@/utils/condition/condition";
import Vue from "vue";
import AppConditionEdit from "../models/ConditionEdit.vue";
import { Field } from "@/utils/documents/field";
import { TranslateResult } from "vue-i18n";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleRowConditionPropSelectGroup } from "@/utils/prop-select/sale-row-to-condition-prop-group";
import { getBankConditionPropSelectGroup } from "@/utils/prop-select/bank-to-condition-prop-group";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { getSaleRowMapPropSelectGroup } from "@/utils/prop-select/sale-row-map-prop-group";
import { getBankMapPropSelectGroup } from "@/utils/prop-select/bank-map-prop-group";
import { getSaleInSaleLayoutPropSelectGroup } from "@/utils/prop-select/sale-in-sale-layout-prop-group";

export default Vue.extend({
	data() {
		return {
			hiddenKeys: [] as string[],
			editStyle: false
		};
	},
	props: {
		value: {
			type: Object as ()=>Field,
			required: true
		},
		selectedLanguage: {
			type: String,
			required: true
		},
		modelName: {
			type: String,
			required: true
		},
		isHeader: Boolean
	},
	computed: {
		propItems():PropSelectGroup{
			if (this.modelName == "Sale"){
				return getSaleMapPropSelectGroup();
			}else if (this.modelName == "SaleRow") {
				return getSaleRowMapPropSelectGroup();
			}
			return getBankMapPropSelectGroup();

		},
		conditionProps():PropSelectGroup{
			if (this.modelName == "Sale") {
				return getSaleInSaleLayoutPropSelectGroup();
			}else if (this.modelName == "SaleRow") {
				return getSaleRowConditionPropSelectGroup(false);
			}
			return getBankConditionPropSelectGroup();
		},
		sectionTitle():TranslateResult{
			if (this.isHeader){
				return this.$ct("column-header");
			}
			return this.$ct("column-body");
		},
	},
	methods: {
		setSelectedLanguage(lang:string){
			this.$emit("update:selectedLanguage", lang);
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.value.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i,1);
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		}
	},
	components: {
		AppConditionEdit,
		AppStyleEditor,
		AppPropSelectAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
